import { ReceivedInvoiceApi, ReceivedInvoiceDataType } from "@/api/ReceivedInvoiceApi"
import { MessageMetadata } from "@/atv/eInvoiceApi"
import { ATV_REJECTED_RESPONSE_CODE } from "./Constants"
import { ReceivedInvoiceMessageData } from "@/formTypes/ReceivedInvoiceDataType"
import { DocumentsIndexPubSub } from "./pubsubs/DocumentIndexPubSub"

export const markRecieveInvoiceAsValidated = async (receivedEmailId: string, messageBody: Partial<MessageMetadata>, invoiceMessageData: Partial<ReceivedInvoiceMessageData>) => {
    try {
        const recievedInvoice = await ReceivedInvoiceApi.getReceivedInvoiceByEmailId(receivedEmailId)

        const status = messageBody.mensaje === ATV_REJECTED_RESPONSE_CODE ? "REJECTED" : "VALIDATED"
        const updatedInvoiceData: ReceivedInvoiceDataType = {
            ...recievedInvoice,
            status,
            ...invoiceMessageData
        }
        await ReceivedInvoiceApi.update(`${recievedInvoice.id}`, updatedInvoiceData)
        DocumentsIndexPubSub.publish({
            modelName: "ReceivedInvoice"
        });

    } catch (err) {
        console.error(err)
    }
}